import { render, staticRenderFns } from "./SelectStudentLinkedParent.vue?vue&type=template&id=163b90ac&scoped=true&"
import script from "./SelectStudentLinkedParent.vue?vue&type=script&lang=js&"
export * from "./SelectStudentLinkedParent.vue?vue&type=script&lang=js&"
import style0 from "./SelectStudentLinkedParent.vue?vue&type=style&index=0&id=163b90ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163b90ac",
  null
  
)

export default component.exports